import React, { Component } from "react";
import { connect } from "react-redux";
import Store from "../../content/Store";
import MemberHelper from "../../helpers/MemberHelper";
import { withRouter, Link } from "react-router-dom";
import { Paths, Urls } from "../../constants/UrlConstants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import InfoBox from "../../components/shared/InfoBox";
import commonStyles from "../../assets/css/modules/myprofile/change-profile-common.css";
import ChangeAddressService from "../../services/ChangeAddressService";
import AddressHelper from "./../../helpers/AddressHelper";
import TextInput from "./../shared/form/TextInput";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import PostCodeValidator from "./../../validations/PostCodeValidation";
import { changeAddress } from "./../../actions/changeaddress/ChangeAddressActions";
import {
  ChangeAddressStatus,
  MyProfileChangeIndicator,
  ChangeAddressContent,
  InsideUKContent
} from "./../../constants/Constants";
import ChooseButton from "../shared/ChooseButton";
import Tooltip from "../shared/Tooltip";
import styles from "../../assets/css/modules/myprofile/change-address.css";
import Contentify from "../../content/Contentify";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import Scroll from "react-scroll";
import { sendDataLayerEvent } from "../../analytics/google/GoogleTagManagerDataLayerEvents";
import { GoogleTagManagerConstants } from "../../analytics/google/GoogleTagManagerConstants";

export function mapStateToChangeAddress(state) {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const redirectUrl = AddressHelper.getChangeAddressLink(selectedPolicy);

  return {
    params: {
      MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber
    },
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    NoOfPolicies:
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.Policies &&
      state.policyReducer.policyDetails.Policies.length,
    MemberAddress: AddressHelper.getAddressAsStringArray(
      currentMember.Address,
      selectedPolicy && selectedPolicy.IsFormat2
    ),
    IsFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    IsLargeCorporate: selectedPolicy && selectedPolicy.IsLargeCorporate,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    IsDependant: !currentMember.IsPolicyHolder,
    IsLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    IsHealthSelect: selectedPolicy && selectedPolicy.IsHealthSelect,
    TelephonePolicyServicing:
      selectedPolicy &&
      selectedPolicy.PolicyServicingTelephones &&
      selectedPolicy.PolicyServicingTelephones.TelephonePolicyServicing,
    RedirectUrl:
      redirectUrl === Paths.ChangeAddress
        ? undefined
        : redirectUrl === null
        ? Paths.NotFound
        : redirectUrl,
    disabled:
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
    featureFlagEP : state && state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeAddress: (changeAddressObject) =>
      dispatch(changeAddress(changeAddressObject))
  };
};

export const updateAddressEventAction = "address";

export class ChangeAddress extends Component {
  static content = Store.ChangeAddress;

  constructor(props) {
    super(props);
    this.state = {
      singleEditMode: false,
      PasswordValidationStatus: {},
      validationErrors: [],
      AddressLine1: "",
      AddressLineTown: "",
      AddressLineCounty: "",
      AddressLinePostCode: "",
      insideUK: undefined,
      mainlandUK: undefined,
      url: Urls.EngagementPortal[EPDomain_ROOT].new
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validateAddress = this.validateAddress.bind(this);
    this.clearForm = this.clearForm.bind(this);
    if (this.props.RedirectUrl) {
      this.props.history.replace(this.props.RedirectUrl);
    }
  }

  handleCallback=(data)=>{
    this.setState({ url: data });
  }

  clearForm() {
    this.setState({
      validationErrors: [],
      AddressLine1: "",
      AddressLineTown: "",
      AddressLineCounty: "",
      AddressLinePostCode: ""
    });
  }

  scrollToName = (name) => {
    Scroll.scroller.scrollTo(name, {
      duration: 750,
      smooth: true
    });
  };

  onSubmit(event) {
    event.preventDefault();

    this.setState({ validationErrors: [] });
    let address = {
      Line1: this.state.AddressLine1.trim(),
      Line2: this.state.AddressLineTown.trim(),
      Line3: this.state.AddressLineCounty.trim(),
      PostCode: this.state.AddressLinePostCode.trim(),
      MembershipNumber: this.props.MembershipNumber
    };
    let errors = this.validateAddress(address);
    if (errors.length > 0) {
      this.setState({ validationErrors: errors });
      return;
    }

    this.props
      .changeAddress(address)
      .then(() => {
        sendDataLayerEvent({
          event: GoogleTagManagerConstants.eventTypes.updateContactDetailsEvent,
          eventAction: updateAddressEventAction
        });
        this.props.history.push({
          pathname: Paths.MyProfile,
          state: { changeIndicator: MyProfileChangeIndicator.Address }
        });
      })
      .catch((error) => {
        let validationErrorsFromServer = [];
        if (
          error.response &&
          error.response.data &&
          error.response.data.ModelState
        ) {
          Object.keys(error.response.data.ModelState).forEach((key) => {
            if (key === ChangeAddressStatus.PostCodeInvalid) {
              validationErrorsFromServer.push(
                this.props.content.ValidationErrors.InvalidFormatServerPostCode
              );
            } else {
              validationErrorsFromServer = [
                this.props.content.ValidationErrors.UpdateFailed
              ];
            }
          });
        } else {
          validationErrorsFromServer = [this.props.content.InternalServerError];
        }
        this.setState({
          validationErrors: validationErrorsFromServer
        });
      });
  }

  validateAddress(address = {}) {
    let errors = [];

    if (!address.Line1) {
      errors.push(this.props.content.ValidationErrors.EmptyAddressLine1);
    }

    if (!address.Line2) {
      errors.push(this.props.content.ValidationErrors.EmptyAddressLineTown);
    }

    if (!address.Line3) {
      errors.push(this.props.content.ValidationErrors.EmptyAddressLineCounty);
    }

    if (!address.PostCode) {
      errors.push(this.props.content.ValidationErrors.EmptyAddressLinePostCode);
    } else if (!PostCodeValidator.isValidPostCode(address.PostCode)) {
      errors.push(this.props.content.ValidationErrors.InvalidFormatPostCode);
    }
    return errors;
  }

  componentDidMount() {
    new ChangeAddressService()
      .GetServiceStatus()
      .catch(() =>{
        if(this.props.featureFlagEP === false || this.props.featureFlagEP === undefined){
        this.props.history.replace(Store.MyProfile.MemberAddress.LinkToFormat1);
        } else if(this.props.featureFlagEP === true){
          this.props.history.replace(Paths.MyProfile);
          window.open(this.state.url, "_blank", "noopener");
        }
      });
  }

  componentDidUpdate() {
    if (this.state.mainlandUK) {
      this.scrollToName(ChangeAddressContent);
    }
  }

  render() {
    return (
      <div className={commonStyles.changeProfile + " " + styles.changeAddress}>
        <h1 className="axa-headline">{this.props.content.Title}</h1>
        {this.props.NoOfPolicies > 1 ? (
          <div id="infoBox" className={commonStyles.infoBox}>
            <InfoBox iconClass={"icon-functional-help"}>
              {this.props.content.InfoBox}
            </InfoBox>
          </div>
        ) : null}
        <div id="memberAddress" className="mb-5">
          <h2 className={styles.addressTitle}>
            {this.props.content.CurrentAddressTitle}
          </h2>

          {this.props.MemberAddress.map((line, key) => (
            <p key={key} className={styles.currentAddress}>
              {line}
            </p>
          ))}
        </div>
        <h2 id="selectAddress" className={styles.addressTitle}>
          {this.props.content.labelSelectAddress}
        </h2>
        <EPQueryParams url={this.state.url} messageType="changeDetails" updatedURL={this.handleCallback}/>
        <div className="row">
          <div className="col-sm-6">
            <ChooseButton
              id="btnInsideUnitedKingdom"
              title={this.props.content.TitleInsideUK}
              selected={this.state.insideUK}
              imgSrc={this.props.content.ImageSource.InsideUKImgSrc}
              onClick={(event) => {
                event.preventDefault();
                this.setState({
                  insideUK: true,
                  mainlandUK: undefined
                });
                this.clearForm();
                this.scrollToName(InsideUKContent);
              }}
            />
          </div>
          <div className="col-sm-6">
            <ChooseButton
              id="btnOutsideUnitedKingdom"
              title={this.props.content.TitleOutsideUK}
              selected={this.state.insideUK === false}
              imgSrc={this.props.content.ImageSource.OutsideUKImgSrc}
              onClick={(event) => {
                event.preventDefault();
                this.setState({
                  insideUK: false,
                  mainlandUK: undefined
                });
              }}
            />
          </div>
        </div>

        <div name={InsideUKContent} />
        {this.state.insideUK === true && !this.props.IsLargeCorporate ? (
          <React.Fragment>
            <h2 id="selectUnitedKingdomAddress" className={styles.addressTitle}>
              {this.props.content.labelSelectUnitedKingdomAddress}
            </h2>
            <ChooseButton
              id="btnMainlandUk"
              title={this.props.content.TitleMainlandUK}
              description={this.props.content.DescMainlandUK}
              selected={this.state.mainlandUK}
              horizontal
              imgSrc={this.props.content.ImageSource.MainlandUKImgSrc}
              onClick={(event) => {
                event.preventDefault();
                this.setState({ mainlandUK: true });
                this.clearForm();
              }}
            />
            <ChooseButton
              id="btnChannelIslands"
              title={this.props.content.TitleChannelIslands}
              description={this.props.content.DescChannelIslands}
              selected={this.state.mainlandUK === false}
              horizontal
              imgSrc={this.props.content.ImageSource.ChannelIslandsImgSrc}
              onClick={(event) => {
                event.preventDefault();
                this.setState({ mainlandUK: false });
                this.scrollToName(InsideUKContent);
              }}
            />
          </React.Fragment>
        ) : null}

        {this.state.insideUK === false ||
        (this.state.insideUK && this.state.mainlandUK === false) ? (
          <div id="outsideUkTooltip">
            <Tooltip
              text={this.props.content.OutsideUkTooltipMessage}
              customStyle={
                this.state.insideUK ? undefined : styles.inputTooltipRight
              }
            />
          </div>
        ) : null}

        <div name={ChangeAddressContent} />
        {this.state.insideUK &&
        (this.state.mainlandUK || this.props.IsLargeCorporate) ? (
          <form id="updateAddressForm" name={ChangeAddressContent}>
            {this.state.validationErrors.length > 0 ? (
              <DisplayValidationErrors
                heading={this.props.content.CorrectErrors}
                errors={this.state.validationErrors}
              />
            ) : null}
            <div id="addressLine1" className="form-group">
              <TextInput
                hasError={false}
                inputValue={this.state.AddressLine1}
                onChange={(event) =>
                  this.setState({ AddressLine1: event.target.value })
                }
                maxLength="36"
                inputId="txtBoxAddressLine1"
                label={this.props.content.labelAddressLine1}
              />
            </div>

            <div id="addressLineTown" className="form-group">
              <TextInput
                hasError={false}
                inputValue={this.state.AddressLineTown}
                onChange={(event) =>
                  this.setState({ AddressLineTown: event.target.value })
                }
                inputId="txtBoxAddressLineTown"
                label={this.props.content.labelAddressLineTown}
                maxLength="36"
              />
            </div>

            <div id="addressLineCounty" className="form-group">
              <TextInput
                hasError={false}
                inputValue={this.state.AddressLineCounty}
                onChange={(event) =>
                  this.setState({ AddressLineCounty: event.target.value })
                }
                inputId="txtBoxAddressLineCounty"
                label={this.props.content.labelAddressLineCounty}
                maxLength="36"
              />
            </div>

            <div id="addressLinePostCode" className="form-group">
              <TextInput
                hasError={false}
                inputValue={this.state.AddressLinePostCode}
                onChange={(event) =>
                  this.setState({ AddressLinePostCode: event.target.value })
                }
                inputId="txtBoxAddressLinePostCode"
                label={this.props.content.labelAddressLinePostCode}
              />
            </div>

            {this.props.IsLargeCorporate ? (
              <Tooltip
                id="largeCorporateTooltip"
                text={this.props.content.LargeCorporateWarning}
              />
            ) : null}

            <div className={commonStyles.actionButtons}>
              <div className="col-sm-6 back-button">
                <Link to={Paths.MyProfile}>
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.content.BackButtonLabel}
                </Link>
              </div>
              <div className="col-sm-6 text-right login">
                <InternalViewButton
                  id="btnAddressUpdate"
                  type="submit"
                  className="form-control btn btn-submit"
                  onClick={this.onSubmit}
                  disabled={this.props.disabled}
                  label={this.props.content.SubmitButtonLabel}
                />
              </div>
            </div>
          </form>
        ) : (
          <div className={commonStyles.actionButtons}>
            <div className="col-sm-6 back-button">
              <Link to={Paths.MyProfile}>
                <span className="mr-2 left-arrow-back">←</span>{" "}
                {this.props.content.BackButtonLabel}
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    mapStateToChangeAddress,
    mapDispatchToProps
  )(Contentify(ChangeAddress))
);
